module.exports = __webpack_public_path__ + "media/images/background-proposal-8044dac4.jpg";